//------------------------Users--------------------------------------------------
export const SET_USER = 'SET_USER';
export const SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED';
export const SET_ADMIN = 'SET_ADMIN';
export const SET_DISABLED = 'SET_DISABLED';
export const SET_ERROR = 'SET_ERROR';
export const USER_ID = 'USER_ID';
export const AUTH_LOADING = 'AUTH_LOADING';
export const USER_LOADING_END = 'USER_LOADING_END';
export const GET_USERS_ALL = 'GET_USERS_ALL';
//------------------Representatives------------------------------------------------
export const CREATE_REPRESENTATIVE = 'CREATE_REPRESENTATIVE';
export const CREATE_REPRESENTATIVE_SUCCESS = 'CREATE_REPRESENTATIVE_SUCCES';
export const CREATE_REPRESENTATIVE_ERROR = 'CREATE_REPRESENTATIVE_ERROR';
export const UPDATE_REPRESENTATIVE_FORM_DATA =
  'UPDATE_REPRESENTATIVE_FORM_DATA';
export const UPDATE_REPRESENTATIVE_SUCCESS = 'UPDATE_REPRESENTATIVE_SUCCESS';
export const UPDATE_REPRESENTATIVE_ERROR = 'UPDATE_REPRESENTATIVE_ERROR';
export const UPDATE_REPRESENTATIVE_LOADING_END =
  'UPDATE_REPRESENTATIVE_LOADING_END';
export const CLEAR_REPRESENTATIVE_FORM_DATA = 'CLEAR_REPRESENTATIVE_FORM_DATA';
export const UPDATE_REPRESENTATIVE = 'UPDATE_REPRESENTATIVE';
export const ASIGNATE_REPRESENTATIVE = 'ASIGNATE_REPRESENTATIVE';
export const GET_REPRESENTATIVE = 'GET_REPRESENTATIVE';
export const GET_REPRESENTATIVE_ERROR = 'GET_REPRESENTATIVE_ERROR';
export const GET_REPRESENTATIVE_BY_ID = 'GET_REPRESENTATIVE_BY_ID';
export const GET_REPRESENTATIVE_BY_ID_ERROR = 'GET_REPRESENTATIVE_BY_ID_ERROR';
export const STATE_TREPRESENTATIVE = 'STATE_REPRESENTATIVE';
export const REPRESENTATIVE_LOADING = 'REPRESENTATIVE_LOADING';
export const REPRESENTATIVE_LOADING_END = 'REPRESENTATIVE_LOADING_END';
//-------------------Students--------------------------------------------------
export const GET_STUDENT = 'GET_STUDENTS';
export const GET_STUDENT_BY_ID = 'GET_STUDENT_BY_ID';
export const GET_STUDENT_ERROR = 'GET_STUDENT_ERROR';
export const GET_STUDENT_BY_ID_ERROR = 'GET_STUDENT_BY_ID_ERROR';
export const STUDENT_LOADING = 'STUDENT_LOADING';
export const STUDENT_LOADING_END = 'STUDENT_LOADING_END';
export const CREATE_STUDENT = 'CREATE_STUDENT';
export const CREATE_STUDENT_SUCCESS = 'CREATE_STUDENT_SUCCESS';
export const CREATE_STUDENT_ERROR = 'CREATE_STUDENT_ERROR';
export const EDIT_STUDENT = 'EDIT_STUDENT';
export const DELETE_STUDENT = 'DELETE_STUDENT';
export const UPDATE_STUDENT_SUCCESS = 'UPDATE_STUDENT_SUCCESS';
export const UPDATE_STUDENT_ERROR = 'UPDATE_STUDENT_ERROR';
export const UPDATE_STUDENT_LOADING_END = 'UPDATE_STUDENT_LOADING_END';
export const UPDATE_STUDENT_FORM_DATA = 'UPDATE_STUDENT_FORM_DATA';
export const CLEAR_STUDENT_FORM_DATA = 'CLEAR_STUDENT_FORM_DATA';
//-----------------Teachers-----------------------------------------------------------
export const CREATE_TEACHER = 'CREATE_TEACHER';
export const CREATE_TEACHER_SUCCESS = 'CREATE_TEACHER_SUCCES';
export const CREATE_TEACHER_ERROR = 'CREATE_TEACHER_ERROR';
export const UPDATE_TEACHER_SUCCESS = 'UPDATE_TEACHER_SUCCES';
export const UPDATE_TEACHER_ERROR = 'UPDATE_TEACHER_ERROR';
export const UPDATE_TEACHER_LOADING_END = 'UPDATE_TEACHER_LOADING_END';
export const UPDATE_TEACHER_FORM_DATA = 'UPDATE_TEACHER_FORM_DATA';
export const CLEAR_TEACHER_FORM_DATA = 'CLEAR_TEACHER_FORM_DATA';
export const ASIGNATE_TEACHER = 'ASIGNATE_TEACHER';
export const GET_TEACHER = 'GET_TEACHER';
export const GET_TEACHER_BY_ID = 'GET_TEACHER_BY_ID';
export const GET_TEACHER_ERROR = 'GET_TEACHER_ERROR';
export const GET_TEACHER_BY_ID_ERROR = 'GET_TEACHER_BY_ID_ERROR';
export const GET_TEACHER_BY_USER_ID_ERROR = 'GET_TEACHER_BY_USER_ID_ERROR';
export const STATE_TEACHER = 'STATE_TEACHER';
export const TEACHER_LOADING = 'TEACHERE_LOADING';
export const TEACHER_LOADING_END = 'TEACHERE_LOADING_END';
//---------------------------Planning--------------------------------
export const PLANNING_LOADING = 'PLANNING_LOADING';
export const PLANNING_LOADING_END = 'PLANNING_LOADING_END';
export const GET_PLANNING = 'GET_PLANNING';
export const GET_PLANNING_ERROR = 'GET_PLANNING_ERROR';
export const GET_PLANNING_BY_ID = 'GET_PLANNING_BY_ID';
export const CREATE_PLANNING = 'CREATE_PLANNING';
export const CREATE_PLANNING_SUCCESS = 'CREATE_PLANNING_SUCCESS';
export const CREATE_PLANNING_ERROR = 'CREATE_PLANNING_ERROR';
export const RESET_PLANNING_SUCCESS = 'RESET_PLANNING_SUCCESS';
export const UPDATE_PLANNING_SUCCESS = 'UPDATE_PLANNING_SUCCES';
export const UPDATE_PLANNING_ERROR = 'UPDATE_PLANNIG_ERROR';
export const ASSIGN_PLANNING_SUCCESS = 'ASSIGN_PLANNING_SUCCESS';
export const ASSIGN_PLANNING_ERROR = 'ASSIGN_PLANNING_ERROR';
export const ASSIGNMENT_LOADING = 'ASSIGNMENT_LOADING';
export const GET_ASSIGNMENTS_SUCCESS = 'GET_ASSIGNMENTS_SUCCESS';
export const GET_ASSIGNMENTS_ERROR = 'GET_ASSIGNMENTS_ERROR';
export const ASSIGNMENT_LOADING_END = 'ASSIGNMENT_LOADING_END';
export const ASSIGN_ATTENDANCE_LIST = 'ASSIGN_ATTENDANCE_LIST';
export const RESET_ASSIGNMENTS = 'RESET_ASSIGNMENTS';
//------------------------------Attendances------------------------------
export const ATTENDANCE_LOADING = 'ATTENDANCE_LOADING';
export const ATTENDANCE_LOADING_END = 'ATTENDANCE_LOADING_END';
export const ATTENDANCE_ERROR = 'ATTENDANCE_ERROR';
export const RESET_ATTENDANCE = 'RESET_ATTENDANCE';
export const GET_ATTENDANCE_BY_ID = 'GET_ATTENDANCE_BY_ID';
export const POST_ATTENDANCE = 'POST_ATTENDANCE';
export const LOCK_ATTENDANCE = 'LOCK_ATTENDANCE';
export const GET_ATTENDANCES_ERROR = 'GET_ATTENDANCES_ERROR';
export const GET_ATTENDANCES_SUCCESS = 'GET_ATTENDANCES_SUCCESS';
export const GET_ATTENDANCES_REQUEST = 'GET_ATTENDANCES_REQUEST';
export const ASSIGN_LIST_REQUEST = 'ASSIGN_LIST_REQUEST';
export const ASSIGN_LIST_SUCCESS = 'ASSIGN_LIST_SUCCESS';
export const ASSIGN_LIST_FAILURE = 'ASSIGN_LIST_FAILURE';
export const GET_ATTENDANCE_LISTS = 'GET_ATTENDANCE_LISTS';
export const GET_ALL_ATTENDANCE_LISTS = 'GET_ALL_ATTENDANCE_LISTS';
export const ERROR_ATTENDANCE_LIST = 'ERROR_ATTENDANCE_LIST';

//-------------------------------PasswordReset---------------------------
export const INITIATE_PASSWORD_RESET = 'INITIATE_PASSWORD_RESET';
export const INITIATE_PASSWORD_RESET_PENDING =
  'INITIATE_PASSWORD_RESET_PENDING';
export const COMPLETE_PASSWORD_RESET = 'COMPLETE_PASSWORD_RESET';
export const COMPLETE_PASSWORD_RESET_ERROR = 'COMPLETE_PASSWORD_RESET_ERROR';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_RESET_ERROR = 'PASSWORD_RESET_ERROR';
export const CLEAR_PASSWORD_RESET = 'CLEAR_PASSWORD_RESET';

//--------------------------------Audits---------------------------------
export const AUDIT_LOADING = "AUDIT_LOADING";
export const GET_AUDITS_SUCCESS = "GET_AUDITS_SUCCESS";
export const GET_AUDITS_ERROR = "GET_AUDITS_ERROR";
